import React from "react";
import { sortableElement, SortableHandle } from "react-sortable-hoc";

import ComponentCard from "./ComponentCard";

const DragHandle = SortableHandle(({ children }) => (
  <div className="flex align-center width-100 sortable-hoc-drag-handle">{children}</div>
));

const SortableCard = sortableElement((props) => {
  return <ComponentCard {...props} HandleComponent={DragHandle} />;
});

const ComponentCards = ({
  inputValues,
  projectData,
  handleModalOpen,
  handleDelete,
  handleDuplicate,
  handleDisable,
  compact,
  isSorted,
  history,
  queryParams,
  setAttributeId,
  setComponentId,
  dragMode,
  suggestedMode,
  setSuggestedMode,
  handleSuggestingAttributes,
  isHorizontalScroll,
  isProcessType,
  numberOpenAIRequests,
  selectedAttributes,
  selectedComponents,
  handleSelectedAttributes,
  handleSelectedComponents,
}) => {
  const componentCards = projectData.components.map((component, index) => {
    const attributes = projectData.attributes.filter((attribute) => attribute.componentId === component.id);
    const activeStatusClass = queryParams.component === component.id ? " active-card-element" : "";

    return (
      <SortableCard
        key={component.id}
        index={index}
        inputValues={inputValues}
        compact={compact}
        isSorted={isSorted}
        component={component}
        attributes={attributes}
        handleModalOpen={handleModalOpen}
        handleDelete={handleDelete}
        handleDuplicate={handleDuplicate}
        handleDisable={handleDisable}
        history={history}
        activeStatusClass={activeStatusClass}
        queryParams={queryParams}
        setAttributeId={setAttributeId}
        setComponentId={setComponentId}
        dragMode={dragMode}
        isProcessType={isProcessType}
        isHorizontalScroll={isHorizontalScroll}
        selectedAttributes={selectedAttributes}
        selectedComponents={selectedComponents}
        handleSelectedAttributes={handleSelectedAttributes}
        handleSelectedComponents={handleSelectedComponents}
        {...{ suggestedMode, setSuggestedMode, handleSuggestingAttributes, numberOpenAIRequests }}
      />
    );
  });

  if (!projectData) {
    return null;
  }

  return componentCards;
};

export default ComponentCards;
